module.exports = __webpack_public_path__ + "media/images/vp/icon.switcher.on.white-ef40ab6053b9a8c267ef6d1161617d6a.png";